import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ChartLineUp } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Register() {
  const { register, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name, email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
        className="w-full max-w-sm">
        <div className="flex items-center gap-3 mb-8">
          <ChartLineUp size={26} weight="bold" className="text-primary" />
          <span className="font-display font-black text-lg tracking-tighter">SheetLens</span>
        </div>
        <p className="text-xs uppercase tracking-[0.16em] text-muted-foreground font-semibold">Mulai gratis</p>
        <h2 className="font-display font-bold text-3xl tracking-tight mt-2 mb-8">Buat akun baru</h2>

        {error && (
          <div className="mb-4 text-sm text-destructive border border-destructive/40 bg-destructive/10 px-3 py-2" data-testid="register-error">
            {error}
          </div>
        )}

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="name" className="text-xs uppercase tracking-widest text-muted-foreground">Nama</Label>
            <Input id="name" required value={name} onChange={(e) => setName(e.target.value)}
              placeholder="Nama Anda" className="mt-1.5" data-testid="register-name-input" />
          </div>
          <div>
            <Label htmlFor="email" className="text-xs uppercase tracking-widest text-muted-foreground">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="anda@perusahaan.com" className="mt-1.5" data-testid="register-email-input" />
          </div>
          <div>
            <Label htmlFor="password" className="text-xs uppercase tracking-widest text-muted-foreground">Kata Sandi</Label>
            <Input id="password" type="password" required minLength={6} value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="Minimal 6 karakter" className="mt-1.5"
              data-testid="register-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full rounded-xl font-semibold" data-testid="register-submit-button">
            {loading ? "Memproses..." : "Daftar"}
          </Button>
        </form>

        <p className="mt-6 text-sm text-muted-foreground">
          Sudah punya akun?{" "}
          <Link to="/login" className="text-primary hover:underline font-medium" data-testid="go-login-link">Masuk</Link>
        </p>
      </motion.div>
    </div>
  );
}
